import { analytics } from 'affiny-core/analytics';
import { config } from 'affiny-core/env';
import { EEnvCountry } from 'affiny-core/env.types';
import { useAccountAttributeElement, useIsSub } from 'affiny-core/hooks';
import { getSubscriptionsAction } from 'affiny-core/modules/subscriptions/actions';
import { selectHashedId } from 'affiny-core/redux/selectors/accountSelectors';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface IAnalyticsInfoUser {
  children: JSX.Element;
}

export const AnalyticsInfoUser = ({ children }: IAnalyticsInfoUser) => {
  const dispatch = useDispatch();

  const hashedAccountId = useSelector(selectHashedId);

  const isSub = useIsSub();

  const myGender = useAccountAttributeElement('gender');

  const age = useAccountAttributeElement('age');

  useEffect(() => {
    dispatch(getSubscriptionsAction());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const ageRange = useMemo(() => {
    if (age) {
      if (age >= 18 && age <= 24) {
        return '18-24';
      } else if (age >= 25 && age <= 27) {
        return '25-27';
      } else if (age >= 28 && age <= 29) {
        return '28-29';
      } else if (age >= 30 && age <= 34) {
        return '30-34';
      } else if (age >= 35 && age <= 39) {
        return '35-39';
      } else if (age >= 40 && age <= 44) {
        return '40-44';
      } else if (age >= 45 && age <= 49) {
        return '45-49';
      } else if (age >= 50 && age <= 54) {
        return '50-54';
      } else if (age >= 55 && age <= 59) {
        return '55-59';
      } else if (age >= 60 && age <= 64) {
        return '60-64';
      } else if (age >= 65 && age <= 69) {
        return '65-69';
      } else if (age >= 70) {
        return '70+';
      }
    }

    return undefined;
  }, [age]);

  useEffect(() => {
    analytics.addInfo({
      hashedAccountId,
      isSub,
      gender: myGender,
      ageRange,
      site_country: config.configStrategy.getCountry() as EEnvCountry,
      site_language: config.configStrategy.getLocale(),
      site_version: 'desktop_web',
      brand_name:
        config.configStrategy.getBrand && config.configStrategy.getBrand(),
    });
  }, [hashedAccountId, isSub, myGender, age, ageRange]);

  return children;
};
